module.exports = __webpack_public_path__ + "media/38.831be3fc.mp3";